<template>
  <!-- https://pastebin.com/JY9HrDxj -->
  <div class="sidebar-nav pt-3">
    <img v-if="!LOGO_DARK" class="logo-big mt-1 mx-auto" src="@/assets/logo-sovrn-bg-dark.png"/>
    <img v-else class="logo-big mt-1 mx-auto" :src="LOGO_DARK"/>
    <img v-if="!LOGO_ICON" class="logo-small mt-1 mx-auto" src="@/assets/icon-multi.png"/>
    <img v-else class="logo-small mt-1 mx-auto" :src="LOGO_ICON"/>
    <b-list-group class="mt-5">
      <div v-for="(nav, index) in items" :key="nav.label">
        <b-list-group-item v-b-toggle="nav.to ? null : nav.label + '-children'"
                           :to="nav.to ? nav.to : null"
                           class="pl-3 cursor-pointer bg-transparent text-white">
          <div :class="{ 'border-admin': nav.label === 'Admin',
                'border-publisher': nav.label === 'Publisher',
                'border-demand': nav.label === 'Demand',
                 'border-exchange': nav.label === 'Network'}"
               class="w-100 border border-left-0 border-right-0 border-top-0">
            {{ nav.label }}
          </div>
        </b-list-group-item>
        <b-collapse :id="nav.label + '-children'" :visible="index === 0">
          <div v-for="child in nav.children" :key="child.label">
            <b-list-group-item :to="child.to ? child.to : null"
                               v-b-toggle="child.children ? nav.label + '-' + child.label + '-children' : false"
                               class="pl-4 bg-transparent cursor-pointer sidebar-nav-entry text-white">
              {{ child.label }}
            </b-list-group-item>
            <b-collapse v-if="child.children"
                        :id="nav.label + '-' + child.label + '-children'">
              <b-list-group>
                <b-list-group-item v-for="navchild in child.children" :key="navchild.label"
                                   class="text-white pl-5 bg-transparent sidebar-nav-entry sidebar-nav-entry-small cursor-pointer"
                                   :to="navchild.to ? navchild.to : null" :href="navchild.href ? navchild.href : null">
                  {{ navchild.label }}
                </b-list-group-item>
              </b-list-group>
            </b-collapse>
          </div>
        </b-collapse>
      </div>
    </b-list-group>
  </div>
</template>

<style>
  .sidebar-nav .nav-item {
    margin: auto !important;
    width: 100%;
  }

  .sidebar-nav .nav-link.active, .sidebar-nav .nav-link:hover {
    color: var(--primary);
  }

  .sidebar-nav-entry {
    color: white;
    font-size: 1.2em;
    text-align: left;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .sidebar-nav-entry-small {
    font-size: 1em !important;
  }

  .sidebar-nav .nav-link .icon {
    position: relative;
    top: 4px;
    font-size: 22px;
  }

  .sidebar-nav-entry:hover, .sidebar-nav-entry.active {
    color: var(--white) !important;
    background-color: rgba(89, 89, 139, 0.2) !important;
    border-color: rgba(0, 0, 0, 0.125) !important;
  }

  .sidebar-nav .child-items .nav-link {
    color: rgba(255, 255, 255, 0.6);
    padding: 0;
    margin: 15px 0;
    height: 40px;
    line-height: 40px;
  }

  .child-items {
    display: none;
  }

  .active .child-items {
    display: block;
    margin-top: 1.5em;
    margin-bottom: -0.5em;
  }

  .sidebar-nav .child-items .nav-link span {
    font-size: 13px;
    font-weight: 600;
  }

  .sidebar-nav .child-items .nav-link .icon {
    top: 2px;
    font-size: 19px;
  }

  .sidebar-nav .logo-big {
    width: 180px;
    display: block;
  }

  .sidebar-nav .logo-small {
    display: none;
    width: 60px;
  }

  .sidebar-nav {
    height: 100%;
    width: 230px;
    background-color: #1D1D2A;
  }

  .sidebar-nav .nav-link {
    white-space: nowrap;
  }

  @media (max-width: 1000px) {
    .sidebar-nav {
      width: 80px;
      text-align: center;
    }

    .sidebar-nav .extend {
      display: none;
    }

    .sidebar-nav .logo-small {
      display: block;
    }

    .sidebar-nav .logo-big {
      display: none;
    }

    .sidebar-nav .child-items span {
      display: none;
    }

    .sidebar-nav .child-items .nav-link i.icon {
      padding-left: 20px !important;
    }
  }
</style>

<script>
    import auth from '@/auth'
    import {getItems as getAdminItems} from '../admin/menuitems'
    import {getItems as getPubItems} from '../publisher/menuitems'
    import {getItems as getDemandItems} from '../demand/menuitems'
    import {getItems as getExchangeItems} from '../exchange/menuitems'

    export default {
      data () {
        return {
          LOGO_DARK,
          LOGO_ICON
        }
      },
        computed: {
            items() {
                return this.getMenuItems()
            }
        },
        methods: {
            getMenuItems() {
                let details = auth.details()

                let navs = []
                if (auth.isAdmin()) {
                    navs.push({icon: 'icon-Support', label: 'Admin', children: getAdminItems(details)})
                  } else {
                    navs.push({to: { name: 'CompanyProfile'}, label: 'Profile', icon: 'icon-Settings'})

                    if (auth.demand()) {
                        navs.push({icon: 'icon-Demand', label: 'Demand', children: getDemandItems(details)})
                    }
                    if (auth.publisher()) {
                        navs.push({icon: 'icon-Publisher', label: 'Publisher', children: getPubItems(details)})
                    }
                    if (auth.exchange()) {
                        navs.push({icon: 'icon-Exchange', label: 'Network', children: getExchangeItems(details)})
                    }
                }

                /* TODO navs.push({to: {name: 'Support'}, label: 'Support', icon: 'icon-Support'}); */
                navs.push({ to: { name: 'Contracts' }, label: 'Contracts' })

                return navs;
            },
            active(item) {
                return (this.$route.path.indexOf(item.to) > -1)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SideNav.vue